import { TButton } from '@variantjs/vue';

const styles = [
    'transition',

    // Text
    'text-center',

    // Dimensions
    'rounded',
    'w-full',

    // States
    'hover:opacity-90',
    'focus:outline-0',
    'focus:ring-0',
    'disabled:opacity-15',
    'disabled:cursor-not-allowed',

    // Display
    'flex',
    'items-center',
    'justify-center',
];

const settings = {
    TButton: {
        component: TButton,
        props: {
            classes: styles,
        },
    },
};

export default settings;
